module.exports = __webpack_public_path__ + "assets/img/bg-06.19406824.jpg";